


































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { GetTownListByParentCode, DeleteTown } from "@/api/pdOutPatient/pdCity";
import addOrEdit from "./addOrEdit.vue";

@Component({
  components: { addOrEdit },
})
export default class extends AbpBase {
  current: any = null;
  townLoading: boolean = false;
  villageLoading: boolean = false;
  addOrEditShow: boolean = false;
  addOrEditData: any = {};

  townData: any = [];
  villageData: any = [];

  columns = [
    {
      title: "编码",
      key: "code",
      minWidth: 120,
    },
    {
      title: "名称",
      key: "name",
      minWidth: 120,
    },
    {
      title: "操作",
      width: 160,
      render: (h: any, p: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: () => {
                  this.deleteCity(p.row);
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];

  getData() {
    this.getTownList();
  }

  addTown() {
    this.addOrEditData = {
      mode: "add",
    };
    this.addOrEditShow = true;
  }

  addVillage() {
    if (!this.current) {
      return;
    }
    this.addOrEditData = {
      mode: "add",
      parentCode: this.current.code,
    };
    this.addOrEditShow = true;
  }

  deleteCity(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteTown(row);
        this.getTownList();
      },
    });
  }

  async getTownList() {
    this.townLoading = true;
    let res = await GetTownListByParentCode({ parentCode: "" });
    this.townLoading = false;
    this.townData = res.objects;
  }

  async getVillageList() {
    if (!this.current) {
      return;
    }
    this.villageLoading = true;
    let res = await GetTownListByParentCode({
      parentCode: this.current.code,
    });
    this.villageLoading = false;
    this.villageData = res.objects;
  }

  handleTownClick(row: any) {
    this.current = row;
    this.getVillageList();
  }

  created() {
    this.getTownList();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/town/index.vue